import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Button } from '@nucleus-commerce/ui/components/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@nucleus-commerce/ui/components/form';
import { Input } from '@nucleus-commerce/ui/components/input';

import { useI18nResolver } from '@/shared/forms/use-i18n-resolver';

import { pasteKeySchema, type PasteKeyValues } from '../../schemas/paste-key-schema';

/** Adds a publishable key someone already has; a secret key is refused with the reason. */
export function PasteKeyForm({ onAdd }: { onAdd: (key: string) => void }) {
  const { t } = useTranslation('docs');
  const form = useForm<PasteKeyValues>({
    resolver: useI18nResolver(pasteKeySchema),
    defaultValues: { key: '' },
  });

  const submit = form.handleSubmit(({ key }) => {
    onAdd(key);
    form.reset();
  });

  return (
    <Form {...form}>
      <form onSubmit={(event) => void submit(event)} noValidate>
        <FormField
          control={form.control}
          name="key"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('keys.paste.label')}</FormLabel>
              <div className="flex gap-2">
                <FormControl>
                  <Input
                    autoComplete="off"
                    spellCheck={false}
                    className="font-mono text-[13px]"
                    placeholder="pk_live_…"
                    {...field}
                  />
                </FormControl>
                <Button type="submit" variant="outline">
                  {t('keys.paste.action')}
                </Button>
              </div>
              <FormMessage />
            </FormItem>
          )}
        />
      </form>
    </Form>
  );
}
